<cwc-error-screen header="500" subHeader="{{translationService.pt('views.errorCodes.OutOfServiceN500')}}"
buttonLabel="{{translationService.pt('views.severalError.GoHome')}}"  (cwcButtonClick)="goHome()" [designVersion]="'v2'">
{{translationService.pt('views.severalError.ContactAdmin')}}</cwc-error-screen>
